export default function Footer() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511993706525', '_blank');
  };

  return (
    <>
      {/* WhatsApp Floating Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 w-20 h-20 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-bounce"
        aria-label="Contato WhatsApp"
      >
        <i className="ri-whatsapp-line text-4xl"></i>
      </button>

      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Investigação Confidencial
              </h3>
              <p className="text-gray-400 mb-4">
                Investigação conjugal discreta e profissional. Seu sigilo está 100% garantido.
              </p>
              <div className="flex space-x-4 mb-3">
                <i className="ri-phone-line text-red-500"></i>
                <span className="text-gray-400">(11) 99370-6525</span>
              </div>
              <div className="flex space-x-4">
                <i className="ri-time-line text-red-500"></i>
                <span className="text-gray-400">Segunda a Sábado: 08h às 20h</span>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Nossos Serviços</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Investigação Conjugal</li>
                <li>Coleta de Evidências</li>
                <li>Relatório Profissional</li>
                <li>Consultoria Confidencial</li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Garantias</h4>
              <ul className="space-y-2 text-gray-400">
                <li>✓ Sigilo Total Garantido</li>
                <li>✓ Investigação Discreta</li>
                <li>✓ Evidências Profissionais</li>
                <li>✓ Suporte Completo</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Investigação Confidencial. Todos os direitos reservados. | 
              <a href="https://www.ovoscomweb.com.br/" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1">
                OvosComWeb
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
